import axios from "axios";
import { NGROK } from "./APIs";
import useCloudSyncStore from "./services/useCloudSyncStore";

export const triggerCloudSync = async (cloud, endpoint, tenantName) => {
  const { setSyncStatus, setSyncTimeout, clearSyncTimeout } = useCloudSyncStore.getState();

  // Clear any existing timeout for this cloud
  clearSyncTimeout(cloud);

  try {
    setSyncStatus(cloud, true);

    // Start the API call asynchronously
    const apiCall = axios.get(`${NGROK}${endpoint}`, {
      params: { tenantName },
    });

    // Calculate expiry time (7 minutes from now)
    const expiryTime = Date.now() + 420000;

    // Set a timeout to reset sync status after 7 minutes (420000 ms)
    const timeoutId = setTimeout(() => {
      setSyncStatus(cloud, false);
      setSyncTimeout(cloud, null);
    }, 420000);

    // Store the timeout ID and expiry time
    setSyncTimeout(cloud, timeoutId, expiryTime);

    const response = await apiCall;
    return response.data;
  } catch (error) {
    console.error(`Error syncing ${cloud.toUpperCase()}:`, error);
    throw error;
  }
};
